/**
 * @generated SignedSource<<c1683eeeb67259c2faa224554c8c108b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AppPushConnectionDataTable_appPushConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly deeplink: string | null;
      readonly id: string;
      readonly isRepeat: boolean;
      readonly nextOccurrences: ReadonlyArray<any>;
      readonly sequence: number;
      readonly startAt: any;
      readonly targetCount: number;
      readonly title: string;
      readonly " $fragmentSpreads": FragmentRefs<"AppPushStatusLabel_appPush">;
    };
  }>;
  readonly " $fragmentType": "AppPushConnectionDataTable_appPushConnection";
};
export type AppPushConnectionDataTable_appPushConnection$key = {
  readonly " $data"?: AppPushConnectionDataTable_appPushConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"AppPushConnectionDataTable_appPushConnection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AppPushConnectionDataTable_appPushConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AppPushEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AppPush",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "AppPushStatusLabel_appPush"
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sequence",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "deeplink",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "targetCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isRepeat",
              "storageKey": null
            },
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "limit",
                  "value": 10
                }
              ],
              "kind": "ScalarField",
              "name": "nextOccurrences",
              "storageKey": "nextOccurrences(limit:10)"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AppPushConnection",
  "abstractKey": null
};

(node as any).hash = "c75f96bbe048b08631672a1b11c33ff2";

export default node;
